// src/utils/auth.js
// Authentication utility functions

const LAST_ACTIVITY_KEY = 'lastActivity';
const INACTIVITY_TIMEOUT_MS = Number(process.env.REACT_APP_SESSION_TIMEOUT_MS) || 2 * 60 * 1000; // default 2 minutes inactivity

/**
 * Update last activity timestamp
 */
export const updateLastActivity = () => {
  localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());
};

/**
 * Check if the current session is valid based on inactivity
 * @returns {boolean} true if session is valid, false if expired due to inactivity
 */
export const isSessionValid = () => {
  const accessToken = localStorage.getItem('accessToken');
  const lastActivity = localStorage.getItem(LAST_ACTIVITY_KEY);
  
  if (!accessToken) {
    return false;
  }
  
  if (!lastActivity) {
    // If no activity timestamp, session is invalid
    return false;
  }
  
  const lastActivityTime = parseInt(lastActivity, 10);
  const currentTime = Date.now();
  const inactiveTime = currentTime - lastActivityTime;
  
  return inactiveTime < INACTIVITY_TIMEOUT_MS;
};

/**
 * Set initial activity timestamp
 */
export const setTokenExpiry = () => {
  updateLastActivity();
};

/**
 * Logout user and clear all session data
 */
export const logout = () => {
  localStorage.clear();
  window.location.href = '/';
};

/**
 * Check session validity and logout if expired
 * @returns {boolean} true if session is valid
 */
export const validateAndRefreshSession = () => {
  const accessToken = localStorage.getItem('accessToken');
  
  // Don't validate if no token exists (user not logged in)
  if (!accessToken) {
    return false;
  }
  
  // Only logout if user has token but session is invalid
  if (!isSessionValid()) {
    logout();
    return false;
  }
  return true;
};
